import { IAppState } from '../types';

export const selectPuids = (state: IAppState) => state.puids.data?.data.params ?? null;

export const selectPuidsHasRequested = (state: IAppState) => state.puids.hasRequested;
